import { render, staticRenderFns } from "./scm_chart.vue?vue&type=template&id=124c4b17&scoped=true"
import script from "./scm_chart.vue?vue&type=script&lang=js"
export * from "./scm_chart.vue?vue&type=script&lang=js"
import style0 from "./scm_chart.vue?vue&type=style&index=0&id=124c4b17&prod&scoped=true&lang=less"
import style1 from "./scm_chart.vue?vue&type=style&index=1&id=124c4b17&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c4b17",
  null
  
)

export default component.exports